<template>
  <div class="iDalgo-Sections">
    <transition-group name="fade">
      <i-dalgo-section
        v-for="(section, key) in sections"
        :key="`section-${key}`"
        :section="section"
        :available="placesAvailable"
        :deletable="sections.length > 1"
        @delete="handleDeleteSection" />
      <div class="iDalgo-Sections__New" :key="-1" v-if="canCreateSection">
        <span class="iDalgo-Sections__New__Button" @click="handleNewSection">
          <svgicon name="cross" :original="true"></svgicon>
          <span>{{ $t('iDalgoListEdit.createSection') }}</span>
        </span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import iDalgoSection from '@/components/iDalgo-Section'
import { mapGetters } from 'vuex'

export default {
  name: 'iDalgo-Sections',
  components: {
    iDalgoSection
  },
  computed: {
    ...mapGetters({
      sections: 'templates/sections',
      size: 'templates/size'
    }),
    placesAvailable () {
      // Return the difference between list size and all the sections sizes
      if (this.sections.length !== 0) {
        return this.size - this.sections.map(section => {
          return section.size
        }).reduce((a, b) => a + b)
      }
      return true
    },
    sectionWithPossibilities () {
      return this.sections.filter(section => section.size > 1)[0]
    },
    canCreateSection () {
      if (this.sections.length > 0) {
        if (this.placesAvailable === 0 && this.sections.filter(section => section.size > 1).length === 0) {
          return false
        }
      }
      return true
    }
  },
  data () {
    return {}
  },
  methods: {
    handleNewSection () {
      if (this.placesAvailable > 0) {
        this.createSection()
        return false
      }
      const availableSection = this.sections.filter(section => section.size > 1)
      if (availableSection.length > 0) {
        this.sections.forEach((s, key) => {
          if (s.id === availableSection[0].id) {
            this.sections[key].size--
          }
        })
        this.createSection()
      }
    },
    createSection () {
      this.$store.commit('templates/SECTIONS_UPDATED', [
        ...this.sections,
        {
          id: '_' + Math.random().toString(36).substr(2, 9),
          name: this.$t('iDalgoListNew.defaultSectionName'),
          size: 1,
          _players: []
        }
      ])
    },
    handleDeleteSection (section) {
      this.$store.dispatch('templates/deleteSection', {
        templateId: this.$route.params.id,
        sectionId: section.id
      })
    }
  }
}
</script>

<style lang="scss">
  .iDalgo-Sections {
    width: 100%;
    display: flex;
    flex-flow: column;

    &__New {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: $default_padding;

      &__Button {
        display: flex;
        flex-flow: column;
        align-items: center;
        font-size: 14px;
        text-transform: uppercase;
        font-family: 'roboto_condensedlight', sans-serif;
        cursor: pointer;

        svg {
          transform: rotate(45deg);
          width: $default_padding * 4;
          height: $default_padding * 4;
          margin-bottom: $default_padding / 2;

          & [pid="0"] {
            transition: all 0.2s;
            fill: lighten($color1, 40%);
          }

          & [pid="1"] {
            fill: $white;
          }
        }

        &:hover {
          svg [pid="0"] {
            fill: lighten($color1, 30%);
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Sections.vue